import { Button, Label, Layout, Panel, Tab, Table, Tabset } from "@mcleod/components";

export abstract class AutogenLayoutPanelPermsGrant extends Layout {
    buttonToggleUsers: Button;
    labelError: Label;
    labelHeading: Label;
    labelSelectItem: Label;
    panelContent: Panel;
    panelHeading: Panel;
    panelLeft: Panel;
    panelSecures: Panel;
    panelUserGroups: Panel;
    tabLmeUsers: Tab;
    tabUserGroups: Tab;
    tabWebUsers: Tab;
    tableGroups: Table;
    tableUsers: Table;
    tableWebUsers: Table;
    tabsetUsers: Tabset;
}
